import React, { Component } from "react";
import { FormSpy } from "react-final-form";

/**
 * AutoSave: Class, component which uses a 5 seconds timeout
 * to call handleSubmit() if autoSaveEnabled is true.
 * 
 * @param {
 * - form
 * - handleSubmit
 * - setLoading
 * - autoSaveEnabled: false is default
 * - validator: validationSchema to make sure the object is complete.
 * - beforeAutoSave: Function tu run before HandleSubmit.
 * } PropTypes
 */
class AutoSave extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isValid: false
    }
  }

  /**
   * Here we will receive props and call autoSave function with debounced logic.
   * TODO This 5 seconds constant 'debounce' may be a prop.
   */
  componentWillReceiveProps() {
    const { autoSaveEnabled, validator, setLoading, beforeAutoSave, handleSubmit, form } = this.props;
    const { isValid } = this.state;
    const { values } = form.getState();
    const debounce = 5000;

    validator.isValid(values)
      .then(result => this.setState({ isValid: result }))
      .catch(() => this.setState({ isValid: false }));

    if (this.timeout) {
      clearTimeout(this.timeout)
    }
    this.timeout = setTimeout(() => {
      saver({ autoSaveEnabled, isValid, setLoading, beforeAutoSave, handleSubmit, form })
    }, debounce)
  }

  /**
   * Render nothing
   */
  render() {
    return null;
  }
};

/**
 * saver: Function to call beforeAutoSave and handleSubmit functions.
 * 
 * @param {
 * - form
 * - handleSubmit
 * - setLoading
 * - autoSaveEnabled: false is default.
 * - isValid: true to allow the saving.
 * - beforeAutoSave: Function tu run before HandleSubmit.
 * } props
 */
const saver = ({ autoSaveEnabled, isValid, setLoading, beforeAutoSave, handleSubmit, form }) => {
  const { pristine } = form.getState();

  if (!pristine && autoSaveEnabled && isValid) {
    setLoading(true);
    beforeAutoSave(form);
    handleSubmit();
  }
};

/**
 * AutoSaveSpy: Allows to receive the change of any form value.
 * Then, we can use AutoSaveComponent.
 * 
 * @param {
 * - form
 * - handleSubmit
 * - setLoading
 * - autoSaveEnabled: false is default
 * - validator: validationSchema to make sure the object is complete.
 * - beforeAutoSave: Function tu run before HandleSubmit.
 * } props
 */
const AutoSaveSpy = props => (<FormSpy {...props} subscription={{ values: true }} component={AutoSave} />)

export default AutoSaveSpy;
